let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gUvh2")).then(() => parcelRequire('hUV1e'));